import { jsx } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
import { useDocument } from "../hooks/use-document";
import { FallbackComponent } from "../../../components/shared/FallbackComponent";
import { Document } from "./Document";
const DocumentReference = memo(
  forwardRef(function DocumentReference2({ documentReference }, ref) {
    const document = useDocument(documentReference.key);
    if (document == null) {
      return /* @__PURE__ */ jsx(FallbackComponent, { ref, text: "Document not found" });
    }
    return /* @__PURE__ */ jsx(Document, { ref, document });
  })
);
export {
  DocumentReference
};
//# sourceMappingURL=DocumentReference.js.map